@if (rendered().length === 0) {
	<div class="fe-empty">No filters. Add one below.</div>
}

@for (entry of rendered(); track entry.index) {
	<div class="fe-filter">
		<div class="fe-filter-head">
			<span class="fe-badge">{{ entry.type || '—' }}</span>
			<div class="fe-filter-actions">
				<button
					pButton
					[text]="true"
					size="small"
					severity="secondary"
					[disabled]="entry.index === 0"
					(click)="moveFilter(entry.index, -1)"
				><i class="pi pi-chevron-up"></i></button>
				<button
					pButton
					[text]="true"
					size="small"
					severity="secondary"
					[disabled]="entry.index === rendered().length - 1"
					(click)="moveFilter(entry.index, 1)"
				><i class="pi pi-chevron-down"></i></button>
				<button
					pButton
					[text]="true"
					size="small"
					severity="danger"
					(click)="removeFilter(entry.index)"
				><i class="pi pi-trash"></i></button>
			</div>
		</div>

		<div class="form-row">
			<div class="form-field">
				<label class="form-label">Type</label>
				<p-select
					[options]="typeOptions"
					optionValue="value"
					[editable]="true"
					appendTo="body"
					[ngModel]="entry.type"
					(ngModelChange)="setType(entry.index, $event)"
					styleClass="p-select-fluid"
				/>
			</div>
			<div class="form-field form-field--check">
				<p-checkbox
					[inputId]="'filter-dynamic-check-' + entry.index"
					[binary]="true"
					[ngModel]="entry.dynamic"
					(ngModelChange)="setDynamic(entry.index, $event)"
				/>
				<label class="form-label" [attr.for]="'filter-dynamic-check-' + entry.index">Dynamic</label>
			</div>
		</div>

		@if (entry.dynamic) {
			<div class="form-row">
				<div class="form-field">
					<label class="form-label">Start Frame</label>
					<p-inputnumber
						[ngModel]="dataNumber(entry.filter, 'startFrame')"
						(ngModelChange)="setFrame(entry.index, 'startFrame', $event)"
						styleClass="p-inputnumber-fluid"
						[showButtons]="false"
					/>
				</div>
				<div class="form-field">
					<label class="form-label">End Frame</label>
					<p-inputnumber
						[ngModel]="dataNumber(entry.filter, 'endFrame')"
						(ngModelChange)="setFrame(entry.index, 'endFrame', $event)"
						styleClass="p-inputnumber-fluid"
						[showButtons]="false"
					/>
				</div>
			</div>
		}

		@if (entry.fields.length > 0) {
			<div class="form-row">
				@for (f of entry.fields; track f.dataKey) {
					@if (f.kind === 'number') {
						<div class="form-field">
							<label class="form-label">
								{{ f.label }}
								@if (f.tooltip) {
									<i
										class="pi pi-info-circle fe-info-icon"
										[pTooltip]="f.tooltip"
										tooltipPosition="top"
									></i>
								}
							</label>
							<p-inputnumber
								[ngModel]="dataNumber(entry.filter, f.dataKey)"
								(ngModelChange)="setNumberField(entry.index, f.dataKey, $event)"
								styleClass="p-inputnumber-fluid"
								[showButtons]="false"
								[step]="f.step ?? 1"
								[minFractionDigits]="0"
								[maxFractionDigits]="3"
							/>
						</div>
					} @else if (f.kind === 'color') {
						<div class="form-field form-field--color">
							<label class="form-label">{{ f.label }}</label>
							<p-colorpicker
								[ngModel]="colorToHex(dataString(entry.filter, f.dataKey))"
								(ngModelChange)="setColorField(entry.index, f.dataKey, hexToColor($event))"
								appendTo="body"
							/>
						</div>
						<div class="form-field">
							<label class="form-label">Hex</label>
							<input
								pInputText
								class="w-full font-mono text-xs"
								[ngModel]="dataString(entry.filter, f.dataKey)"
								(ngModelChange)="setColorField(entry.index, f.dataKey, $event)"
								placeholder="#000000"
							/>
						</div>
					}
				}
			</div>
		}
	</div>
}

<div class="fe-add-row">
	<p-select
		[options]="typeOptions"
		optionValue="value"
		appendTo="body"
		[ngModel]="newType()"
		(ngModelChange)="newType.set($event)"
		styleClass="p-select-fluid fe-add-select"
	/>
	<button
		pButton
		size="small"
		severity="secondary"
		(click)="addFilter()"
	><i class="pi pi-plus"></i>Add filter</button>
</div>
